import { useEffect, useState } from 'react';
import { CallsApi } from '../../api/resources';

/** Loads a recording with the user's auth token (an <audio src> can't send it) and plays it. */
export default function RecordingPlayer({ recording }) {
  const [url, setUrl] = useState(null);
  const [state, setState] = useState('idle'); // idle | loading | failed

  useEffect(
    () => () => {
      if (url) URL.revokeObjectURL(url);
    },
    [url]
  );

  const load = async () => {
    setState('loading');
    try {
      setUrl(URL.createObjectURL(await CallsApi.recordingBlob(recording.id)));
      setState('idle');
    } catch {
      setState('failed');
    }
  };

  if (url) return <audio src={url} controls autoPlay style={{ height: 32, maxWidth: 260 }} />;
  if (state === 'failed') return <span className="muted">Recording unavailable</span>;
  return (
    <button className="btn btn-sm" onClick={load} disabled={state === 'loading'}>
      {state === 'loading' ? 'Loading…' : '▶ Play'}
    </button>
  );
}
